"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowInterviewInputSchema = exports.WorkflowSurveyInputSchema = exports.InterviewEntitySchema = exports.SurveyEntitySchema = exports.SurveyQuestionSchema = void 0;
exports.WorkflowSurveySubmitInputSchema = WorkflowSurveySubmitInputSchema;
const zod_1 = __importDefault(require("zod"));
exports.SurveyQuestionSchema = zod_1.default.object({
    key: zod_1.default.string(),
    type: zod_1.default.any(), // Replace with a more specific type if known
    display_name: zod_1.default.string(),
    description: zod_1.default.string().nullable().default(null),
    note: zod_1.default.string().nullable().default(null),
    required: zod_1.default.boolean().default(true),
    options: zod_1.default
        .array(zod_1.default.object({
        label: zod_1.default.string(),
        value: zod_1.default.string(),
    }))
        .nullable()
        .default(null),
});
exports.SurveyEntitySchema = zod_1.default.object({
    id: zod_1.default.string(),
    questions: zod_1.default.array(exports.SurveyQuestionSchema),
});
exports.InterviewEntitySchema = zod_1.default.object({
    id: zod_1.default.string(),
});
exports.WorkflowSurveyInputSchema = zod_1.default.object({
    survey: zod_1.default.union([zod_1.default.string(), exports.SurveyEntitySchema]),
    asset: zod_1.default.number({ coerce: true }),
});
exports.WorkflowInterviewInputSchema = zod_1.default.object({
    // interview: z.union([z.string(), InterviewEntitySchema]),
    interview: zod_1.default.string(),
    asset: zod_1.default.number({ coerce: true }).nullable().default(null),
    prompt: zod_1.default.string().optional(),
});
function WorkflowSurveySubmitInputSchema(data) {
    return zod_1.default.object({
        survey: zod_1.default.string({ description: 'The slug of dataset to submit answers for' }),
        asset: zod_1.default.number(),
        data,
    });
}
//# sourceMappingURL=workflowSurveySchema.js.map